import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-edit-contratas',
  templateUrl: './edit-contratas.component.html',
  styleUrls: ['./edit-contratas.component.scss']
})
export class EditContratasComponent implements OnInit {

  // displayedColumns = ['NOMBRE', 'BORRAR'];
  displayedColumns = ['INDEX', 'ACCION', 'CONTRATA', 'ASIGNACION', 'BORRAR'];
  grupoVal = new FormGroup({
    ACCION: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    CONTRATA: new FormControl(null, [Validators.compose([
      Validators.required
    ])]),
    ASIGNACION: new FormControl(null)
  });

  acciones = [
    { ID: 1, NOMBRE: 'Agregar' },
    { ID: 2, NOMBRE: 'Eliminar' }
  ];

  // Todas las contratas existentes
  contratasall = [];
  contratasAsignadas = [];
  contratas = [];
  asignaciones = [];

  listaSub = [];
  dataSource;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<EditContratasComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }

  async ngOnInit() {
    if (this.data.operacion == 'Editar') {
      await this.getContratasall();
      await this.getContratasAsignadas(this.data.campana);
    }
    this.dataSource = new MatTableDataSource<any>(this.listaSub);
  }

  getContratasall() {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.gateway.get('getdistribuidor',
        {
          IDPADRE: this.localSave.get('usuarioPGV').IDU,
          IDAREA: this.localSave.get('usuarioPGV').IDAREA,
          NUM_PAGINA: 0,
          FILTRO: null,
          NUM_ELEMENTOS: 10000,
          IDPAIS: 5
        })
        .then((result: any) => {
          let aux: any = result;
          this.contratasall = aux.rows;
          this.spinner.hide();
          resolve(true);
        }).catch((e: any) => {
          this.spinner.hide();
          resolve(false);
        });
    });
  }

  getContratasAsignadas(campana?: any) {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.gateway.get('getdistribuidorxcampanapadre',
        {
          IDCAMPANAPADRE: campana.idcampana
        })
        .then((result: any) => {
          let aux: any = result;
          this.contratasAsignadas = aux.rows;
          this.spinner.hide();
          resolve(true);
        }).catch((e: any) => {
          this.spinner.hide();
          resolve(false);
        });
    });
  }

  onAccionSeleccionada(event: any) {
    // alert(event.value);
    this.grupoVal.controls.CONTRATA.setValue(null);
    this.grupoVal.controls.ASIGNACION.setValue(null);

    if (event.value == 1) { // Agregar

      this.grupoVal.get('ASIGNACION').setValidators(Validators.compose([]))
      this.grupoVal.get('ASIGNACION').updateValueAndValidity();

      this.contratas = this.contratasall.filter(
        c => !this.contratasAsignadas.some(a => a.iddistribuidor == c.iddistribuidor)
      );
    } else { // Eliminar

      this.grupoVal.get('ASIGNACION').setValidators(Validators.compose([Validators.required]))
      this.grupoVal.get('ASIGNACION').updateValueAndValidity();

      this.contratas = [...this.contratasAsignadas];
      this.contratas = this.contratas.filter(
        c => !this.listaSub.some(a => a.contrata['iddistribuidor'] == c.iddistribuidor)
      );

      let contrata = this.grupoVal.controls.CONTRATA.value || {};
      let contrataasig = this.contratasall.filter(
        c => ![contrata].some(a => a.iddistribuidor == c.iddistribuidor)
      );

      this.asignaciones = [{ iddistribuidor: 0, nombre: 'Distribuir equitativamente a las contratas asignadas.' }, ...contrataasig]
    }
  }

  onContrataSeleccionada(event: any) {
    // alert(event.value);
    this.grupoVal.controls.ASIGNACION.setValue(null);

    let contrata = this.grupoVal.controls.CONTRATA.value || {};
    let contrataasig = this.contratasall.filter(
      c => ![contrata].some(a => a.iddistribuidor == c.iddistribuidor)
    );
    this.asignaciones = [{ iddistribuidor: 0, nombre: 'Distribuir equitativamente a las contratas asignadas.' }, ...contrataasig]
  }

  agregarRegistro() {
    let i = 0;
    const index = this.listaSub.findIndex(sub => (
      sub.accion == this.grupoVal.controls.ACCION.value &&
      sub.contrata['iddistribuidor'] == this.grupoVal.controls.CONTRATA.value['iddistribuidor'] &&
      (this.grupoVal.controls.ASIGNACION.value ? (sub.asignacion['iddistribuidor'] == this.grupoVal.controls.ASIGNACION.value['iddistribuidor']) : true)
    ));
    // const index1 = this.listaSub.findIndex(sub => sub.accion.toString().toLowerCase() === (this.grupoVal.controls.ACCION.value.toString().trim()).toLowerCase());
    // const index2 = this.listaSub.findIndex(sub => sub.contrata.toLowerCase() === (this.grupoVal.controls.CONTRATA.value['nombre'].trim()).toLowerCase());
    // const index3 = this.listaSub.findIndex(sub => sub.asignacion.toLowerCase() === (this.grupoVal.controls.ASIGNACION.value['nombre'].trim()).toLowerCase());
    // console.log(index);
    if (index > -1) {
      this.snackbar.open('Ya existe una acción para esta contrata.', '', {
        duration: 3000
      });
      this.dataSource = new MatTableDataSource<any>(this.listaSub);
    } else {

      let insertar = true;
      if (this.grupoVal.controls.ACCION.value == 2 && this.grupoVal.controls.ASIGNACION.value['iddistribuidor'] == 0) {
        insertar = false;
        const hayContratasAsig = this.contratas.length > 1;
        const hayAccionUno = this.listaSub.some(item => item.accion == 1);

        insertar = hayAccionUno || hayContratasAsig;
      } else {
        insertar = true;
      }

      if (insertar) {
        this.listaSub.push({
          accion: this.grupoVal.controls.ACCION.value,
          contrata: this.grupoVal.controls.CONTRATA.value,
          asignacion: this.grupoVal.controls.ASIGNACION.value
        });
        this.grupoVal.reset();
        this.dataSource = new MatTableDataSource<any>(this.listaSub);
      } else {
        this.snackbar.open('ERROR: No puede eliminar la siguiente contrata porque la campaña no puede quedarse sin contratas.', '', {
          duration: 7000
        });
      }
    }
  }

  borrar(element) {
    let auxind = -1;
    auxind = this.listaSub.indexOf(element);
    this.listaSub.splice(auxind, 1)
    this.dataSource = new MatTableDataSource(this.listaSub);

    //this.dataSource = new MatTableDataSource<any>(this.listaSub);
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    let datos = {
      ...this.data.campana,
      IDCAMPANA: this.data.campana.idcampana,
      IDUSUARIO: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA,
      TAREAS: this.listaSub
    };

    this.spinner.show();
    this.gateway.save('editarcampanaxcontrata', datos).then((result) => {
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }
}
